// Service de gestion des notifications

let notificationId = 0;
let listeners = [];

export const notificationService = {
  // Ajouter un listener pour les notifications
  subscribe(listener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },

  // Notifier tous les listeners
  notify(notification) {
    listeners.forEach(listener => listener(notification));
  },

  // Méthodes helper pour différents types de notifications
  success(title, message, duration = 5000) {
    this.notify({
      id: ++notificationId,
      type: 'success',
      title,
      message,
      duration
    });
  },

  error(title, message, duration = 7000) {
    this.notify({
      id: ++notificationId,
      type: 'error',
      title,
      message,
      duration
    });
  },

  warning(title, message, duration = 6000) {
    this.notify({
      id: ++notificationId,
      type: 'warning',
      title,
      message,
      duration
    });
  },

  info(title, message, duration = 5000) {
    this.notify({
      id: ++notificationId,
      type: 'info',
      title,
      message,
      duration
    });
  },

  // Notifications spécifiques à l'application
  membreEnregistre(membre) {
    this.success(
      'Membre enregistré avec succès',
      `Le membre ${membre.nom} ${membre.prenom} a été enregistré. Matricule: ${membre.numero_matricule}`,
      6000
    );
  },

  paiementEnregistre(paiement) {
    this.success(
      'Paiement enregistré',
      `Paiement de ${parseFloat(paiement.montant).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} CDF enregistré. Reçu: ${paiement.numero_recu}`,
      6000
    );
  },

  rappelPaiement(membre, cotisationsImpayees) {
    this.warning(
      'Rappel de paiement',
      `${membre.nom} ${membre.prenom} a ${cotisationsImpayees} cotisation(s) impayée(s)`,
      8000
    );
  },

  montantMensuelDefini(montant, cotisationsCreees) {
    this.success(
      'Montant mensuel défini',
      `Montant mensuel de ${parseFloat(montant.montant_mensuel).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} CDF fixé. ${cotisationsCreees} cotisation(s) créée(s)`,
      7000
    );
  },

  montantHebdomadaireCalcule(montantHebdomadaire) {
    this.info(
      'Montant hebdomadaire calculé',
      `Montant hebdomadaire: ${parseFloat(montantHebdomadaire).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} CDF`,
      5000
    );
  }
};


